/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Redigeringen är klar',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Gör ändringar',
  'editor-common-extensibility.macro.button.configure': 'Konfigurera {macroName}',
  'fablric.editor.viewAllInserts': 'Visa alla infogningar',
  'fabric.editor.action': 'Uppgift',
  'fabric.editor.action.description': 'Skapa och tilldela åtgärdsuppgifter',
  'fabric.editor.addAltText': 'Alternativ text',
  'fabric.editor.addColumnLeft': 'Lägg till kolumn till vänster',
  'fabric.editor.addColumnRight': 'Lägg till kolumn till höger',
  'fabric.editor.addCommentOnMedia': 'Lägg till kommentar',
  'fabric.editor.addImageBorder': 'Lägg till kant',
  'fabric.editor.addLoomVideo': 'Spela in en Loom-video',
  'fabric.editor.addLoomVideoComment': 'Spela in en Loom-videokommentar',
  'fabric.editor.addMediaFiles': 'Lägg till en bild, video eller fil',
  'fabric.editor.addRowAbove': 'Lägg till rad ovanför',
  'fabric.editor.addRowBelow': 'Lägg till rad nedanför',
  'fabric.editor.addUpdatedAltText': 'Lägg till alternativ text',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Använd Atlassian Intelligence för att hitta åtgärdsobjekt och visa dem i en panel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Panel för åtgärdsobjekt (Beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Använd Atlassian Intelligence för att sammanfatta sidan och visa den i en panel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Sammanfattningspanel för sida (Beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Markerat innehåll',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Skapar innehåll som ska infogas på sidan',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Sammanfattar sidans innehåll',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generera',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Fråga Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Redigera',
  'fabric.editor.ai.config.item.action.insert': 'Infoga',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Infoga överst',
  'fabric.editor.ai.config.item.action.insertBelow': 'Infoga nedan',
  'fabric.editor.ai.config.item.action.replace': 'Ersätt',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Ändra titel',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Titeln får inte överstiga {maxLength} tecken',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Öppna i chatt',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo-agent',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Kortar ner innehållet för att göra det mer koncist',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Förkorta uppdateringen',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Skapar en beskrivning av pull-begärande med en sammanfattning av ändringar',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Ange beskrivning för pull-begärande',
  'fabric.editor.ai.config.item.brainstorm.description': 'Genererar en lista med idéer för ett ämne du anger',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Ge mig ämnet …',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorma',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorma',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Ändrar tonen för innehållet till informell',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Informell',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Informell',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Ändra tonen till informell',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Ändrar tonen för innehållet till pedagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Pedagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Pedagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Ändra tonen till pedagogisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Ändrar tonen för innehållet till empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Ändra tonen till empatisk',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Ändra tonen till ...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Ändrar tonen för innehållet till neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Ändra tonen till neutral',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'Ändrar tonen för innehållet till professionell',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionell',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionell',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Ändra tonen till professionell',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Formaterar om innehållet till en punktlista',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Konvertera till punktlista',
  'fabric.editor.ai.config.item.convertToTable.description': 'Formaterar om innehåll till en tabell med rubriker',
  'fabric.editor.ai.config.item.convertToTable.title': 'Konvertera till tabell',
  'fabric.editor.ai.config.item.draftReply.description':
    'Utarbetar ett svar baserat på ärenden som liknar det du arbetar med',
  'fabric.editor.ai.config.item.draftReply.title': 'Skriv svar',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Korrigerar stavnings- och grammatikfel',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Stavning och grammatik',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Korrigera stavning och grammatik',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Förbättrar tydlighet, struktur och ton för en mer engagerande och välskriven text',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Förbättra skrivande',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Förbättra skrivande',
  'fabric.editor.ai.config.item.findActionItems.description': 'Hittar åtgärder i innehållet du tillhandahåller',
  'fabric.editor.ai.config.item.findActionItems.title': 'Hitta åtgärder',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Välj nedan (fri generering är inaktiverad i Elevate just nu)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Skriv med AI eller välj nedan',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Omstrukturera ärendebeskrivningen baserat på ärendetypen',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Förbättra beskrivning',
  'fabric.editor.ai.config.item.makeLonger.description': 'Utökar innehållet utifrån sammanhanget du tillhandahåller',
  'fabric.editor.ai.config.item.makeLonger.title': 'Gör längre',
  'fabric.editor.ai.config.item.range.agent.description': 'Beskrivning saknas',
  'fabric.editor.ai.config.item.range.agent.prompt.hint': 'Be agenten att skriva något eller välj nedan',
  'fabric.editor.ai.config.item.rephrase.description': 'Skapar ett förslag på hur dina meningar kan omformuleras',
  'fabric.editor.ai.config.item.rephrase.title': 'Omformulera',
  'fabric.editor.ai.config.item.shorten.description': 'Kortar ner innehållet för att göra det mer koncist',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Gör kortare',
  'fabric.editor.ai.config.item.shorten.title': 'Gör kortare',
  'fabric.editor.ai.config.item.suggest.description': 'Föreslår en rubrik för innehållet du tillhandahåller',
  'fabric.editor.ai.config.item.suggest.title': 'Föreslå en titel',
  'fabric.editor.ai.config.item.summarize.description':
    'Skapar en sammanfattning av texten du arbetar med och markerar viktiga punkter',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Sammanfatta text',
  'fabric.editor.ai.config.item.summarize.title': 'Sammanfatta text',
  'fabric.editor.ai.config.item.translate.czech': 'Tjeckisk',
  'fabric.editor.ai.config.item.translate.danish': 'Danska',
  'fabric.editor.ai.config.item.translate.dutch': 'Holländska',
  'fabric.editor.ai.config.item.translate.english': 'sv-SE',
  'fabric.editor.ai.config.item.translate.finnish': 'Finska',
  'fabric.editor.ai.config.item.translate.french': 'Franska',
  'fabric.editor.ai.config.item.translate.german': 'Tyska',
  'fabric.editor.ai.config.item.translate.hungarian': 'Ungerska',
  'fabric.editor.ai.config.item.translate.italian': 'Italienska',
  'fabric.editor.ai.config.item.translate.japanese': 'Japanska',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Översätt',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Översätt till ...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norska',
  'fabric.editor.ai.config.item.translate.russian': 'Ryska',
  'fabric.editor.ai.config.item.translate.spanish': 'Spanska',
  'fabric.editor.ai.config.item.translate.swedish': 'Svenska',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Översätter texten du arbetar med till kinesiska (förenklad)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Översätt till kinesiska (förenklad)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Översätter texten du arbetar med till kinesiska (traditionell)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Översätt till kinesiska (traditionell)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Översätter texten du arbetar med till tjeckiska',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Översätt till tjeckiska',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Översätter texten du arbetar med till danska',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Översätt till danska',
  'fabric.editor.ai.config.item.translateTo.dutch.description': 'Översätter texten du arbetar med till nederländska',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Översätt till nederländska',
  'fabric.editor.ai.config.item.translateTo.english.description': 'Översätter texten du arbetar med till engelska',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Översätt till engelska',
  'fabric.editor.ai.config.item.translateTo.finnish.description': 'Översätter texten du arbetar med till finska',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Översätt till finska',
  'fabric.editor.ai.config.item.translateTo.french.description': 'Översätter texten du arbetar med till franska',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Översätt till franska',
  'fabric.editor.ai.config.item.translateTo.german.description': 'Översätter texten du arbetar med till tyska',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Översätt till tyska',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Översätter texten du arbetar med till ungerska',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Översätt till ungerska',
  'fabric.editor.ai.config.item.translateTo.italian.description': 'Översätter texten du arbetar med till italienska',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Översätt till italienska',
  'fabric.editor.ai.config.item.translateTo.japanese.description': 'Översätter texten du arbetar med till japanska',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Översätt till japanska',
  'fabric.editor.ai.config.item.translateTo.korean.description': 'Översätter texten du arbetar med till koreanska',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Översätt till koreanska',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Översätter texten du arbetar med till norska',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Översätt till norska',
  'fabric.editor.ai.config.item.translateTo.polish.description': 'Översätter texten du arbetar med till polska',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Översätt till polska',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Översätter texten du arbetar med till portugisiska (brasilianska)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Översätt till portugisiska (brasilianska)',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Översätter texten du arbetar med till ryska',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Översätt till ryska',
  'fabric.editor.ai.config.item.translateTo.spanish.description': 'Översätter texten du arbetar med till spanska',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Översätt till spanska',
  'fabric.editor.ai.config.item.translateTo.swedish.description': 'Översätter texten du arbetar med till svenska',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Översätt till svenska',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Översätter texten du arbetar med till thailändska',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Översätt till thailändska',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Översätter texten du arbetar med till turkiska',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Översätt till turkiska',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description': 'Översätter texten du arbetar med till ukrainska',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Översätt till ukrainska',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Översätter texten du arbetar med till vietnamesiska',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Översätt till vietnamesiska',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Ändra ton',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Skriv om',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Översätt',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Sidrubrik',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Sida',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vi har problem med att infoga svaret. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Vi kan inte generera förhandsvisningen. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Vi har fått för många förfrågningar om Atlassian Intelligence (AI) den senaste tiden. Försök igen om några minuter eller läs om <link>överdriven användning av AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Det gick inte att få ett svar. Din uppmaning eller ditt svar överskred gränsen för denna förfrågan. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage': 'Vi har problem. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience.apiError': 'Vi kunde inte få ett svar, försök igen.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Din uppmaning eller ditt innehåll kanske inte följer vår policy för godtagbar användning. Granska båda och hänvisa till vår <link>policy för godtagbar användning</link> om det behövs. Om problemet kvarstår kan du överväga att prova en annan uppmaning eller ett annat innehåll.',
  'fabric.editor.ai.experience.browseMore.agents': 'Bläddra bland agenter',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Vill du kassera din uppmaning?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Vill du kassera ditt svar?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': 'Fri generering är inaktiverad i Elevate just nu.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Nu kan du klistra in länkar 🔗 till Jira- och Confluence-innehåll i dina uppmaningar.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Drivs av Rovo',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence kunde inte behandla din förfrågan eftersom innehållet innehåller länkar till HIPAA-begränsat innehåll. Ta bort länkarna och försök igen.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Innehållet är för kort för att sammanfatta. Lägg till mer och försök igen.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) svarar inte. Försök igen senare eller <link>kontrollera status för AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Genererar',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyserar: granskar din fråga.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Söker: vänta ett ögonblick medan vi söker efter information.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Söker: vänta ett ögonblick, vi söker i Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Söker: vänta ett ögonblick med vi söker på sidan.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Inga resultat',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence har inga förslag just nu. Prova gärna en annan uppmaning eller ett annat innehåll.',
  'fabric.editor.ai.experience.showMoreButton': 'Visa mer',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Åtgärder',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenter',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Kunskapskälla',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-agenter',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-agenter ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Använd en Rovo-agent ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Använd allmän kunskap',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Använd kunskap från din organisation',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Vi kan inte generera förhandsvisningen. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage': 'Vi har problem. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Infoga nedan',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Ersätt',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Förfrågningar om innehållsgenerering som refererar till webbadresser är i betastadiet.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Markera en term, akronym eller förkortning',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definiera',
  'fabric.editor.ai.toolbar.askAI.title': 'Fråga Atlassian Intelligence',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Förbättra skrivande',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Säg åt Atlassian Intelligence att förbättra en vald text',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Prova AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Öppna Atlassian Intelligence',
  'fabric.editor.alignCenter': 'Centrera',
  'fabric.editor.alignImageCenter': 'Centrera',
  'fabric.editor.alignImageLeft': 'Vänsterjustera',
  'fabric.editor.alignImageRight': 'Högerjustera',
  'fabric.editor.alignLeft': 'Vänsterjustera',
  'fabric.editor.alignRight': 'Högerjustera',
  'fabric.editor.alignTableCenter': 'Centrera',
  'fabric.editor.alignTableLeft': 'Vänsterjustera',
  'fabric.editor.alignment': 'Textjustering',
  'fabric.editor.altText': 'Alt-text',
  'fabric.editor.alttext.validation': 'Ta bort eventuella specialtecken i alternativ text.',
  'fabric.editor.annotationToolbar': 'Verktygsfält för kommentarer',
  'fabric.editor.backLink': 'Gå tillbaka',
  'fabric.editor.backgroundColor': 'Bakgrundsfärg',
  'fabric.editor.blockCardUnavailable': 'Inlinelänken är inuti {node} och det går inte att byta dess vy',
  'fabric.editor.blockControlDelete': 'Radera',
  'fabric.editor.blockControlDragHandleMove': 'Dra för att flytta',
  'fabric.editor.blockControlDragHandleRearrange': 'Dra för att ordna om',
  'fabric.editor.blockControlInsert': 'Infoga',
  'fabric.editor.blockControlMoveDown': 'Flytta ner',
  'fabric.editor.blockControlMoveLeft': 'Flytta åt vänster',
  'fabric.editor.blockControlMoveRight': 'Flytta åt höger',
  'fabric.editor.blockControlMoveUp': 'Flytta upp',
  'fabric.editor.blockControlMovedDown': 'Innehållet har flyttats ner',
  'fabric.editor.blockControlMovedUp': 'Innehållet har flyttats upp',
  'fabric.editor.blockDescription': 'Visa mer information om en länk, inklusive en sammanfattning och åtgärder',
  'fabric.editor.blockTitle': 'Kort',
  'fabric.editor.blockquote': 'ett citattecken',
  'fabric.editor.blockquote.description': 'Infoga citat',
  'fabric.editor.blockquote2': 'Citera',
  'fabric.editor.bold': 'Fet',
  'fabric.editor.breakoutFullWidthLabel': 'Full bredd',
  'fabric.editor.breakoutWideWidthLabel': 'Bred',
  'fabric.editor.bug': 'Bugg',
  'fabric.editor.canNotSortTable': '⚠️ Du kan inte sortera en panelvy med sammanslagna celler',
  'fabric.editor.cancelButton': 'Avbryt',
  'fabric.editor.captionPlaceholder': 'Lägg till en bildtext',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Lägg till en bildtext – dubbelklicka för att förhandsgranska',
  'fabric.editor.cardFloatingControls': 'Kortalternativ',
  'fabric.editor.cellBackground': 'Cellbakgrund',
  'fabric.editor.cellOptions': 'Cellalternativ',
  'fabric.editor.checkUncheckActionItem': 'Växla åtgärdsobjekt',
  'fabric.editor.clearAltTextEdit': 'Rensa alternativ text',
  'fabric.editor.clearCells': '{0, plural, one {Rensa cell} other {Rensa celler}}',
  'fabric.editor.clearFormatting': 'Ta bort formatering',
  'fabric.editor.clearLink': 'Rensa länk',
  'fabric.editor.clearLinkText': 'Rensa text',
  'fabric.editor.closeAltTextEdit': 'Tillbaka',
  'fabric.editor.closeFindReplaceDialog': 'Stäng',
  'fabric.editor.closeHelpDialog': 'Stäng hjälpdialog',
  'fabric.editor.code': 'Kod',
  'fabric.editor.code.on': '{textFormattingOff}, kod på',
  'fabric.editor.codeBidiWarningLabel':
    'Dubbelriktade tecken ändrar återgivningsordningen för text. Detta kan användas för att dölja skadlig kod.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Kopierad!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopiera som text',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Inaktivera brytning',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Aktivera brytning',
  'fabric.editor.codeblock': 'Kodstycke',
  'fabric.editor.codeblock.description': 'Visa kod med syntaxmarkering',
  'fabric.editor.collapseNode': 'komprimera innehåll',
  'fabric.editor.collapseTable': 'Dölj tabell',
  'fabric.editor.colorPicker.menuLabel': 'Meny för färgväljare',
  'fabric.editor.columnDragHandle': 'Kolumnalternativ',
  'fabric.editor.columnMovedLeft': 'Kolumnen flyttades åt vänster till {index} av {total}',
  'fabric.editor.columnMovedRight': 'Kolumnen flyttades åt höger till {index} av {total}',
  'fabric.editor.columnSelected': 'Kolumn {index} av {total} markerad',
  'fabric.editor.columns': 'Layouter',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Infoga {numberOfColumns} likadan kolumn} other {Infoga {numberOfColumns} likadana kolumner}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Infoga layout med en kolumn',
  'fabric.editor.columns.description': 'Ge din sida struktur med sektioner',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {En kolumn har infogats} other {{count} kolumner har infogats}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Kolumnen har tagits bort} other {{count} kolumner har tagits bort}}',
  'fabric.editor.configFailedToLoad': 'Fel vid inläsning',
  'fabric.editor.configPanel.cancel': 'Avbryt',
  'fabric.editor.configPanel.close': 'Stäng',
  'fabric.editor.configPanel.customSelect.createOption': 'Skapa',
  'fabric.editor.configPanel.dateRange.custom.from': 'Från',
  'fabric.editor.configPanel.dateRange.custom.to': 'Till',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Dölj',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Expandera',
  'fabric.editor.configPanel.dateRange.option.custom': 'Anpassat',
  'fabric.editor.configPanel.documentation': 'Dokumentation',
  'fabric.editor.configPanel.errorBoundary.note':
    'Vi har meddelat teamet. Du kan fortfarande redigera och publicera sidan eller kontrollera felkonsolen för mer information.',
  'fabric.editor.configPanel.errorBoundary.title': 'Något gick fel.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Kan inte kombinera isMultiple med stilen radio',
  'fabric.editor.configPanel.formType.addField': 'Lägg till fält',
  'fabric.editor.configPanel.formType.removeField': 'Ta bort fält',
  'fabric.editor.configPanel.help': 'Behöver du hjälp?',
  'fabric.editor.configPanel.invalid': 'Ogiltigt fält',
  'fabric.editor.configPanel.required': 'Obligatoriskt fält',
  'fabric.editor.configPanel.submit': 'Skicka in',
  'fabric.editor.copiedToClipboard': 'Kopierad!',
  'fabric.editor.copyToClipboard': 'Kopiera',
  'fabric.editor.cornerControl': 'Markera tabellen',
  'fabric.editor.createComment': 'Kommentera',
  'fabric.editor.createCommentDisabled':
    'Du kan bara kommentera text, rubriker, emojis, datum, omnämnanden, länkar och statusar.',
  'fabric.editor.createCommentInvalid': 'Du kan bara kommentera på text och rubriker',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Jag förstår',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Nu kan nu lämna kommentarer i infogade delar som länkar, datum, statusar och omnämnanden.',
  'fabric.editor.customPanel': 'Anpassad panel',
  'fabric.editor.customPanel.description': 'Lägg till en anteckning med en emoji och en färgad bakgrund',
  'fabric.editor.datasource.assetsObjects.description':
    'Infoga objekt från Tillgångar i Jira Service Management med sökning och filtrering',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Tillgångar',
  'fabric.editor.datasource.confluenceSearch': 'Infoga Confluence-lista',
  'fabric.editor.datasource.confluenceSearch.description':
    'Infoga lista över sökresultat från Confluence med förbättrad sökning, filtrering och konfiguration.',
  'fabric.editor.datasource.jiraIssue': 'Jira-ärenden',
  'fabric.editor.datasource.jiraIssue.description':
    'Infoga Jira-ärenden från Jira Cloud med förbättrad sökning, filtrering och konfiguration.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Infoga Jira-arbetsobjekt från Jira Cloud med förbättrad sökning, filtrering och konfiguration.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-arbetsuppgifter',
  'fabric.editor.datasourceAppearanceTitle': 'Lista',
  'fabric.editor.datasourceTitle': 'Redigera sökfråga',
  'fabric.editor.date': 'Datum',
  'fabric.editor.date.description': 'Lägg till ett datum med en kalender',
  'fabric.editor.datePickerOpenedAlert':
    'Popup-fönster för datumväljare öppnades, tryck på Tab för att komma åt datumväljaren',
  'fabric.editor.decision': 'Beslut',
  'fabric.editor.decision.description': 'Fånga beslut så att de är enklare att spåra',
  'fabric.editor.decisionPlaceholder': 'Lägg till ett beslut ...',
  'fabric.editor.decreaseSize': 'Minska tabell- eller mediastorlek',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Radera',
  'fabric.editor.description': 'Beskrivning',
  'fabric.editor.displayBlock': 'Visa kort',
  'fabric.editor.displayEmbed': 'Visa inbäddad',
  'fabric.editor.displayInline': 'Visa inline',
  'fabric.editor.displayLink': 'Visa som text',
  'fabric.editor.displayOptionUnavailableInParentNode':
    'Det här visningsalternativet är inte tillgängligt inuti {node}',
  'fabric.editor.displayText': 'Text att visa',
  'fabric.editor.distributeColumns': 'Fördela kolumner',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Visa en interaktiv förhandsvisning av en länk',
  'fabric.editor.edit': 'Redigera',
  'fabric.editor.edit.datasource': 'Redigera sökfråga',
  'fabric.editor.edit.searchInput': 'Lägg till en länk',
  'fabric.editor.editAccessTitle': 'Du behöver redigeringsåtkomst',
  'fabric.editor.editAltText': 'Redigera alternativ text',
  'fabric.editor.editDatasourceStandalone': 'Redigera',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Redigera sökfråga',
  'fabric.editor.editDateText': 'Redigeringsdatum',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Redigera sökfråga',
  'fabric.editor.editDropdownEditLinkTitle': 'Redigera länk',
  'fabric.editor.editDropdownExpandIconLabel': 'Expandera rullgardinsmeny',
  'fabric.editor.editDropdownTriggerTitle': 'Redigera',
  'fabric.editor.editLink': 'Redigera länk',
  'fabric.editor.editMode.inviteToEditButton.title': 'Bjud in att redigera',
  'fabric.editor.editStatusColor': 'Redigera statusfärg',
  'fabric.editor.editStatusText': 'Redigera status',
  'fabric.editor.editableContentLabel': 'Innehåll som kan redigeras',
  'fabric.editor.editorHelp': 'Editor-hjälp',
  'fabric.editor.editors': 'Redigerare',
  'fabric.editor.elementBrowser.help': 'Hjälp',
  'fabric.editor.elementInsertSidePanel.title': 'Infoga',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Alla',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Kommunikation',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence-innehåll',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Utveckling',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Externt innehåll',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatering',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Media',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigering',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapportering',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Grafik och bilder',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Ingenting matchar din sökning',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Prova att söka med en annan term eller upptäck nya appar för Atlassian-produkter.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Utforska Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Ingenting matchar din sökning.} one {{count} förslag tillgängligt som standard.} other {{count} förslag tillgängliga som standard.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Ingenting matchar din sökning.} one {{count} förslag tillgängliga för skriven text.} other {{count} förslag tillgängliga för skriven text.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Retur',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Sök',
  'fabric.editor.elementbrowser.sidebar.heading': 'Bläddra',
  'fabric.editor.embedTitle': 'Bädda in',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Använd emojis för att uttrycka idéer 🎉 och känslor 😄',
  'fabric.editor.emptyLink': 'Ange en länk.',
  'fabric.editor.emptySearchResults': 'Vi hittade inga resultat.',
  'fabric.editor.emptySearchResultsSuggestion': 'Välj {buttonName} om du vill bläddra bland infogningar.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Fel',
  'fabric.editor.errorPanel': 'Felpanel',
  'fabric.editor.errorPanel.description': 'Meddela om fel i en färgad panel',
  'fabric.editor.expand': 'Expandera',
  'fabric.editor.expand.description': 'Infoga expandering',
  'fabric.editor.expandAriaLabel': 'Ge expanderingen en titel',
  'fabric.editor.expandDefaultTitle': 'Klicka här för att expandera ...',
  'fabric.editor.expandNode': 'Expandera innehåll',
  'fabric.editor.expandPlaceholder': 'Ge expanderingen en titel ...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Om du raderar {nodeName} bryts allt som är kopplat till den.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Raderar',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Radera',
  'fabric.editor.extension.deleteElementTitle': 'Radera element',
  'fabric.editor.extension.sourceNoTitledName': 'detta element',
  'fabric.editor.extensions.config-panel.save-indicator': 'Alla ändringar sparas alltid automatiskt',
  'fabric.editor.externalExtensionsHeading': 'Appar',
  'fabric.editor.externalMediaFile': 'Extern mediefil',
  'fabric.editor.failed_to_upload': 'Uppladdning misslyckades',
  'fabric.editor.feedbackDialog': 'Ge feedback',
  'fabric.editor.feedbackDialog.description': 'Berätta för oss om din upplevelse av den nya redigeraren',
  'fabric.editor.find': 'Hitta',
  'fabric.editor.findNext': 'Hitta nästa',
  'fabric.editor.findPrevious': 'Hitta föregående',
  'fabric.editor.findReplaceToolbarButton': 'Sök och ersätt',
  'fabric.editor.fiveColumns': 'Layout med fem kolumner',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Avbryt',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Radera även anslutna element',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 anslutet element)} other {{name} (+{amount,number} anslutna element)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Är du säker?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Svävande verktygsfält har öppnats',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Svävande verktygsfält',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layout-alternativ',
  'fabric.editor.floatingToolbar.scrollLeft': 'Bläddra åt vänster',
  'fabric.editor.floatingToolbar.scrollRight': 'Bläddra åt höger',
  'fabric.editor.focusTableResizeHandle': 'Handtag för att ändra storlek på fokustabell',
  'fabric.editor.fourColumns': 'Layout med fyra kolumner',
  'fabric.editor.headerColumn': 'Rubrikkolumn',
  'fabric.editor.headerRow': 'Rubrikrad',
  'fabric.editor.heading1': 'Rubrik 1',
  'fabric.editor.heading1Description': 'Använd för rubrik på översta nivån',
  'fabric.editor.heading2': 'Rubrik 2',
  'fabric.editor.heading2Description': 'Använd för viktiga avsnitt',
  'fabric.editor.heading3': 'Rubrik 3',
  'fabric.editor.heading3Description': 'Använd för underavsnitt och grupprubriker',
  'fabric.editor.heading4': 'Rubrik 4',
  'fabric.editor.heading4Description': 'Använd för rubriker längre ner',
  'fabric.editor.heading5': 'Rubrik 5',
  'fabric.editor.heading5Description': 'Använd för att gruppera listobjekt',
  'fabric.editor.heading6': 'Rubrik 6',
  'fabric.editor.heading6Description': 'Använd för rubriker på låg nivå',
  'fabric.editor.headingLink.ascOrderLabel': 'Sortera kolumn Ö till A',
  'fabric.editor.headingLink.descOrderLabel': 'Rensa sortering',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blogg',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bugg',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Ärende',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Arbetsuppgift',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Sida',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Uppgift',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Du kan inte sortera en panelvy med sammanslagna celler',
  'fabric.editor.headingLink.noOrderLabel': 'Sortera kolumn A till Ö',
  'fabric.editor.help': 'Hjälp',
  'fabric.editor.help.description': 'Bläddra bland alla tangentbordsgenvägar och Markdown-alternativ',
  'fabric.editor.helpDialogTips': 'Tryck på {keyMap} för att när som helst öppna den här dialogrutan',
  'fabric.editor.highlight': 'Markeringsfärg',
  'fabric.editor.highlightColor': 'Växla palett för markeringsfärg',
  'fabric.editor.highlightFloatingToolbar': 'Markering',
  'fabric.editor.horizontalRule': 'Avgränsare',
  'fabric.editor.horizontalRule.description': 'Separera innehåll med en horisontell linje',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Klistra in eller sök efter en länk',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Förslag visas nedan när du skriver i fältet',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {inga resultat hittades} one {{count,number} resultat hittades} other {{count,number} resultat hittades}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Visningstext (valfritt)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Klistra in eller sök efter en länk',
  'fabric.editor.image': 'Bild',
  'fabric.editor.image.fullWidthLabel': 'Full bredd',
  'fabric.editor.imageBorderBold': 'Fetstil',
  'fabric.editor.imageBorderColor': 'Färg',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Listruta för bildkantsalternativ för färg',
  'fabric.editor.imageBorderMedium': 'Medium',
  'fabric.editor.imageBorderOptions': 'Kantalternativ',
  'fabric.editor.imageBorderSize': 'Storlek',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Listruta för bildkantsalternativ för storlek',
  'fabric.editor.imageBorderSubtle': 'Diskret',
  'fabric.editor.improvement': 'Förbättring',
  'fabric.editor.increaseSize': 'Öka tabell- eller mediastorlek',
  'fabric.editor.indent': 'Indrag',
  'fabric.editor.info': 'Info',
  'fabric.editor.infoPanel': 'Informationspanel',
  'fabric.editor.infoPanel.description': 'Markera information med en färgad panel',
  'fabric.editor.inlineConfigureLink': 'Konfigurera länk',
  'fabric.editor.inlineDescription': 'Visa länk som infogad text',
  'fabric.editor.inlineGoToLink': 'Gå till länk',
  'fabric.editor.inlineOverlay': 'Konfigurera',
  'fabric.editor.inlineTitle': 'Inline',
  'fabric.editor.inputQueryAssistiveTxt':
    'När autokompletteringsresultat är tillgängliga använder du upp- och nedpilarna för att granska och Enter för att välja. Användare med pekskärm kan utforska genom att röra vid skärmen eller svepa på den.',
  'fabric.editor.insertColumn': 'Infoga kolumn till höger',
  'fabric.editor.insertColumnDrag': 'Infoga kolumn',
  'fabric.editor.insertMenu': 'Infoga element',
  'fabric.editor.insertRightRail.close': 'Stäng',
  'fabric.editor.insertRightRail.title': 'Infoga',
  'fabric.editor.insertRow': 'Infoga rad nedanför',
  'fabric.editor.insertRowDrag': 'Infoga rad',
  'fabric.editor.insertTableColumn': 'Infoga tabellkolumn',
  'fabric.editor.insertTableRow': 'Infoga tabellrad',
  'fabric.editor.invalidDateError': 'Ange ett giltigt datum',
  'fabric.editor.invalidLink': 'Ange en giltig länk.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Bjud in teammedlem till {productName}} trusted {Bjud in teammedlem till {productName}} other {Lägg till teammedlem i {productName}}}',
  'fabric.editor.italic': 'Kursiv',
  'fabric.editor.keyboardShortcuts': 'Kortkommandon',
  'fabric.editor.layout.columnOption': '{count, plural, one {Kolumn} other {{count} kolumner}}',
  'fabric.editor.layout.controls.placeholder': '/ för att infoga',
  'fabric.editor.layout.placeholder': 'Lägg till innehåll',
  'fabric.editor.layout.resizeLayout': 'Ändra storlek på layout',
  'fabric.editor.layoutFixedWidth': 'Tillbaka till centrera',
  'fabric.editor.layoutFullWidth': 'Använd full bredd',
  'fabric.editor.layoutStateFixedWidth': 'Centrerad',
  'fabric.editor.layoutStateFullWidth': 'Full bredd',
  'fabric.editor.layoutStateWide': 'Bred',
  'fabric.editor.layoutWide': 'Använd bred',
  'fabric.editor.leftSidebar': 'Layout med vänster sidopanel',
  'fabric.editor.link': 'Länk',
  'fabric.editor.link.description': 'Infoga länk',
  'fabric.editor.linkAddress': 'Länkadress',
  'fabric.editor.linkPlaceholder': 'Klistra in länk',
  'fabric.editor.lists': 'Listor',
  'fabric.editor.listsFormat': 'Listformatering',
  'fabric.editor.lockColumns': 'Fasta kolumnbredder',
  'fabric.editor.longEmptyNodePlaceholderText': 'Ange / om du vill infoga element',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Matcha skiftläge',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Mediabredden har minskats till {newMediaWidth,number} pixel.} other {Mediabredden har minskats till {newMediaWidth,number} pixlar.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Mediabredden har ökats till {newMediaWidth,number} pixel.} other {Mediabredden har ökats till {newMediaWidth,number} pixlar.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Media har minskats till minsta storlek',
  'fabric.editor.media.insert.cancel': 'Avbryt',
  'fabric.editor.media.insert.fileTabTitle': 'Fil',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Vi kan tyvärr inte lägga till den här bildlänken. Ladda ner bilden och dra och släpp den på sidan.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Bilden kanske inte är synlig för andra på grund av källbegränsningar. Överväg att ladda upp filen istället.',
  'fabric.editor.media.insert.insert': 'Infoga',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Ogiltig länk',
  'fabric.editor.media.insert.linkTabTitle': 'Länk',
  'fabric.editor.media.insert.loadPreview': 'Läs in förhandsgranskning',
  'fabric.editor.media.insert.localFileErrorMessage': 'Det gick inte att ladda upp filen.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Fel vid filuppladdning. Kontrollera filsökvägen eller nätverket.',
  'fabric.editor.media.insert.mediaAlt': 'Förhandsgranskning av uppladdad bild- eller videofil',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Medieväljare',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Klistra in länk för att ladda upp',
  'fabric.editor.media.insert.upload': 'Ladda upp',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Media har ökats till maximal storlek',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Ändra storlek',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Stäng',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'höjdingång',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Höjd',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maxbredd {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Bredd',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maxbredd {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Omvandla till pixlar',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migrera från procent till fast pixelstorlek',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Skicka in',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Validering för bredd misslyckades',
  'fabric.editor.mediaAddLink': 'Lägg till länk',
  'fabric.editor.mediaFiles': 'Bild, video eller fil',
  'fabric.editor.mediaFiles.description': 'Lägg till bilder och andra filer till din sida',
  'fabric.editor.mediaGroupDeleteLabel': 'radera',
  'fabric.editor.media_change_mediainline_caption_warn': 'Inline (bildtext tas bort)',
  'fabric.editor.media_change_mediainline_default': 'Inline',
  'fabric.editor.media_change_mediasingle': 'Originalstorlek',
  'fabric.editor.mention': 'Omnämnande',
  'fabric.editor.mention.description': 'Nämn någon för att skicka en avisering till dem',
  'fabric.editor.mentionNode.label': 'Taggade användaren',
  'fabric.editor.mentionsAddLabel': 'lägg till-ikon',
  'fabric.editor.mentionsIconLabel': 'Omnämnande',
  'fabric.editor.mergeCells': 'Sammanfoga celler',
  'fabric.editor.moreFormatting': 'Mer formatering',
  'fabric.editor.moveColumnLeft': '{0, plural, one {Flytta kolumn åt vänster} other {Flytta kolumner åt vänster}}',
  'fabric.editor.moveColumnRight': '{0, plural, one {Flytta kolumn åt höger} other {Flytta kolumner åt höger}}',
  'fabric.editor.moveDownDown': '{0, plural, one {Flytta rad nedåt} other {Flytta rader nedåt}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Flytta rad uppåt} other {Flytta rader uppåt}}',
  'fabric.editor.navigate.toolbar.editor': 'Gå till verktygsfältet för redigering',
  'fabric.editor.navigate.toolbar.floating': 'Gå till det svävande verktygsfältet',
  'fabric.editor.noResultsFound': 'Inga resultat',
  'fabric.editor.noSearchResults': 'Inga sökresultat',
  'fabric.editor.normal': 'Normal text',
  'fabric.editor.note': 'Anteckning',
  'fabric.editor.notePanel': 'Anteckningspanel',
  'fabric.editor.notePanel.description': 'Lägg till en anteckning i en färgad panel',
  'fabric.editor.numberedColumn': 'Numrerad kolumn',
  'fabric.editor.off': '{formattingType} av',
  'fabric.editor.offlineErrorFallbackDescription': 'Försök uppdatera sidan.',
  'fabric.editor.offlineErrorFallbackHeading': 'Något gick fel!',
  'fabric.editor.on': '{formattingType} på',
  'fabric.editor.openCellOptions': 'Öppna cellalternativ',
  'fabric.editor.openLink': 'Öppna länk i en ny flik',
  'fabric.editor.orderedList': 'Numrerad lista',
  'fabric.editor.orderedList.description': 'Skapa en sorterad lista',
  'fabric.editor.other': 'Annat ...',
  'fabric.editor.outdent': 'Utdrag',
  'fabric.editor.overflowMenuViewMore': 'Visa mer',
  'fabric.editor.pageActionsLabel': 'Sidåtgärder',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Bakgrundsfärg',
  'fabric.editor.panel.custom': 'Anpassat',
  'fabric.editor.panel.emoji': 'Lägg till emoji',
  'fabric.editor.panel.panelsGroup': 'Paneltyper',
  'fabric.editor.pasteOptions': 'Inklistringsalternativ',
  'fabric.editor.pastePlainText': 'Klistra in oformaterad text',
  'fabric.editor.placeholderAltText': 'Beskriv den här bilden med alternativ text',
  'fabric.editor.placeholderText': 'Platshållartext',
  'fabric.editor.placeholderText.description': 'Infoga en platshållare för text på sidan',
  'fabric.editor.placeholderTextPlaceholder': 'Lägg till platshållartext',
  'fabric.editor.plainText': 'Använd oformaterad text',
  'fabric.editor.preferencesLink': 'Länkinställningar',
  'fabric.editor.quickInsert': 'Snabbinfoga',
  'fabric.editor.recordLoomShortTitle': 'Spela in',
  'fabric.editor.recordVideo': 'Spela in en Loom-video',
  'fabric.editor.recordVideo.description': 'Spela in och dela din skärm och dina tankar',
  'fabric.editor.redo': 'Gör om',
  'fabric.editor.remove': 'Ta bort',
  'fabric.editor.removeColumns': '{0, plural, one {Radera kolumn} other {Radera kolumner}}',
  'fabric.editor.removeEmoji': 'Ta bort emoji',
  'fabric.editor.removeImageBorder': 'Ta bort kanten',
  'fabric.editor.removeRows': '{0, plural, one {Radera rad} other {Radera rader}}',
  'fabric.editor.replace': 'Ersätt',
  'fabric.editor.replaceAll': 'Ersätt alla',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} matchning ersatt} other {{numberOfMatches,number} matchningar ersatta}}',
  'fabric.editor.replaceWith': 'Ersätt med',
  'fabric.editor.requestToEdit': 'Förfrågan om att redigera',
  'fabric.editor.requestToEditDescription': 'När du begär åtkomst får sidans ägare ett meddelande.',
  'fabric.editor.requestToEditDismiss': 'Avfärda',
  'fabric.editor.resultsCount': '{selectedMatchPosition} av {totalResultsCount}',
  'fabric.editor.richText': 'Använd RTF',
  'fabric.editor.rightSidebar': 'Layout med höger sidopanel',
  'fabric.editor.rowControl': 'Markera raden',
  'fabric.editor.rowDragHandle': 'Radalternativ',
  'fabric.editor.rowMovedDown': 'Raden flyttades ner till {index} av {total}',
  'fabric.editor.rowMovedUp': 'Raden flyttades upp till {index} av {total}',
  'fabric.editor.rowSelected': 'Rad {index} av {total} markerad',
  'fabric.editor.rowsAreInserted': '{count, plural, one {En rad har infogats} other {{count} rader har infogats}}',
  'fabric.editor.rowsAreRemoved': '{count, plural, one {Raden har tagits bort} other {{count} rader har tagits bort}}',
  'fabric.editor.saveButton': 'Spara',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} sökresultat tillgängligt. Använd uppåt- och nedåtpilarna för att bläddra bland alternativen. Tryck på Enter för att välja ett alternativ.} other {{itemsLength,number} sökresultat tillgängliga. Använd uppåt- och nerpilarna för att bläddra bland alternativen. Tryck på Enter för att välja ett alternativ.}}',
  'fabric.editor.selectColumnResize': 'Välj storleksändring av kolumn',
  'fabric.editor.selectLanguage': 'Välj språk',
  'fabric.editor.selectTableColumn': 'Välj tabellkolumn',
  'fabric.editor.selectTableRow': 'Välj tabellrad',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Välj app',
  'fabric.editor.settingsLinks': 'Gå till länkinställningar',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ för att infoga',
  'fabric.editor.shortcut': 'Textgenväg',
  'fabric.editor.single': 'Layout med en kolumn',
  'fabric.editor.singleColumns': 'Layout med en kolumn',
  'fabric.editor.sortColumnASC': 'Sortera kolumn A → Ö',
  'fabric.editor.sortColumnDESC': 'Sortera kolumn Ö → A',
  'fabric.editor.sortColumnDecreasing': 'Sortera fallande',
  'fabric.editor.sortColumnIncreasing': 'Sortera stigande',
  'fabric.editor.splitCell': 'Dela cell',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Lägg till en anpassad statusetikett',
  'fabric.editor.statusEditorLabel': 'Statusredigerare',
  'fabric.editor.statusPickerOpenedAlert':
    'Popup-fönster för statusväljare öppnades. Tryck på Tab för att komma åt statusväljaren',
  'fabric.editor.statusPlaceholder': 'Ange status',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Genomstrykning',
  'fabric.editor.subTask': 'Underordnad uppgift',
  'fabric.editor.subscript': 'Nedsänkt',
  'fabric.editor.subscript.off.superscript.on': 'Nedsänkt text av, upphöjd text på',
  'fabric.editor.success': 'Klart!',
  'fabric.editor.successPanel': 'Framgångspanel',
  'fabric.editor.successPanel.description': 'Lägg till ett tips i en färgad panel',
  'fabric.editor.superscript': 'Upphöjd',
  'fabric.editor.superscript.off.subscript.on': 'Upphöjd text av, nedsänkt text på',
  'fabric.editor.supportAltText':
    'Alternativ text är användbart för de som använder skärmläsare på grund av visuella begränsningar.',
  'fabric.editor.table': 'Tabell',
  'fabric.editor.table.description': 'Infoga en tabell',
  'fabric.editor.tableAlignmentOptions': 'Justeringsalternativ',
  'fabric.editor.tableFullWidthLabel': 'Full bredd',
  'fabric.editor.tableHeader.sorting.asc': 'Stigande sortering används',
  'fabric.editor.tableHeader.sorting.default': 'Sortera kolumnen',
  'fabric.editor.tableHeader.sorting.desc': 'Fallande sortering används',
  'fabric.editor.tableHeader.sorting.invalid': 'Du kan inte sortera en tabell med sammanslagna celler',
  'fabric.editor.tableHeader.sorting.no': 'Ingen sortering används på kolumnen',
  'fabric.editor.tableOptions': 'Tabellalternativ',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabellbredden har minskats till {newWidth,number} pixel.} other {Tabellbredden har minskats till {newWidth,number} pixlar.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabellbredden har ökat till {newWidth,number} pixel.} other {Tabellbredden har ökat till {newWidth,number} pixlar.}}',
  'fabric.editor.tableSelector': 'Tabellstorlek',
  'fabric.editor.tableSelector.description':
    'Lägg till en tabell och använd popup-fönstret för att välja en anpassad storlek',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} av {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Väljare för tabellstorlek',
  'fabric.editor.tables.adjustColumn': 'Justera kolumn',
  'fabric.editor.tables.columnResizeLast': 'Du kan bara ändra storlek på kolumnen till vänster.',
  'fabric.editor.tables.columnResizeOverflow':
    'Du kan bara ändra storlek på kolumnen när tabellen har en rullningslist.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Kolumnbredden har ändrats till {width} pixel.} other {Kolumnbredden har ändrats till {width} pixlar}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Om du raderar {nodeName} bryts allt som är kopplat till den.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Radera',
  'fabric.editor.tables.resizeStop': 'Storleksändring har avbrutits',
  'fabric.editor.tables.resizeTable': 'Ändra storlek på tabell',
  'fabric.editor.tables.startedColumnResize': 'Storleksändring av kolumn har påbörjats',
  'fabric.editor.task': 'Uppgift',
  'fabric.editor.taskPlaceholder': 'Skriv din åtgärd och använd @ för att tilldela någon.',
  'fabric.editor.text.formatting.off': 'Textformatering av',
  'fabric.editor.textColor': 'Textfärg {selectedColorName}',
  'fabric.editor.textColorTooltip': 'Textfärg',
  'fabric.editor.textFormat': 'Formatera text',
  'fabric.editor.textFormatting': 'Textformatering',
  'fabric.editor.textStyles': 'Textstilar {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Textstilar',
  'fabric.editor.threeColumns': 'Layout med tre kolumner',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Layout med tre kolumner och sidopanel vänster',
  'fabric.editor.threeColumnsWithRightSidebars': 'Layout med tre kolumner och sidopanel höger',
  'fabric.editor.threeColumnsWithSidebars': 'Layout med tre kolumner och sidopaneler',
  'fabric.editor.time.ago': 'sedan',
  'fabric.editor.time.updated': 'Uppdaterad',
  'fabric.editor.time.viewed': 'Visad',
  'fabric.editor.toolbarAppears': 'Verktygsfältet visas',
  'fabric.editor.toolbarLabel': 'Redigerare',
  'fabric.editor.toolbarMediaTitle': 'Lägg till en bild, video eller fil',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fäst längst upp',
  'fabric.editor.toolbarPositionInline': 'I linje med texten',
  'fabric.editor.tooltip.blockPanel': 'en panel',
  'fabric.editor.tooltip.bulletList': 'en lista',
  'fabric.editor.tooltip.decisionList': 'en beslutslista',
  'fabric.editor.tooltip.defaultBlockNode': 'en blockeringsslutpunkt',
  'fabric.editor.tooltip.nestedExpand': 'en staplad expanderingsslutpunkt',
  'fabric.editor.tooltip.taskList': 'ett åtgärdsobjekt',
  'fabric.editor.turnInto': 'Omvandla till',
  'fabric.editor.twoColumns': 'Layout med två kolumner',
  'fabric.editor.typeAhead.popupLabel': 'Autoförslagsresultat',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Börja skriva för att söka eller filtrera genvägsalternativ',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Sök',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Genvägar för infogningar och formatering',
  'fabric.editor.typeahead.emojiInputLabel': 'Börja skriva för att söka eller filtrera emojialternativ',
  'fabric.editor.typeahead.emojiListItemLabel': 'Emoji {name} Textgenväg {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Emojigenvägar',
  'fabric.editor.typeahead.mentionInputLabel': 'Börja skriva för att söka efter användare att tagga',
  'fabric.editor.typeahead.mentionPopupLabel': 'Användare som du kan tagga',
  'fabric.editor.typeahead.metionListItemLabel': 'Användare {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Vi kunde inte läsa in innehållet',
  'fabric.editor.unableToOpenLink': 'Det gick inte att öppna länken',
  'fabric.editor.underline': 'Understruken',
  'fabric.editor.undo': 'Ångra',
  'fabric.editor.unknown.label': 'Okänd',
  'fabric.editor.unlink': 'Ta bort länk',
  'fabric.editor.unorderedList': 'Punktlista',
  'fabric.editor.unorderedList.description': 'Skapa en osorterad lista',
  'fabric.editor.unsupportedBlockContent': 'Denna redigerare har inte stöd för visning av detta innehåll',
  'fabric.editor.unsupportedContentTooltip':
    'Innehållet är inte tillgängligt i denna redigerare, detta bevaras när du redigerar och sparar',
  'fabric.editor.unsupportedInlineContent': 'Innehåll utan stöd',
  'fabric.editor.upDown': 'Använd upp- och nedpilarna i följande inmatningsfält för att uppdatera datumet nedan',
  'fabric.editor.url': 'Visa URL',
  'fabric.editor.urlDescription': 'Visa länk som URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Använd Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Visa och lägg till kommentarer',
  'fabric.editor.viewCommentOnMedia': 'Visa kommentarer',
  'fabric.editor.viewMore': 'Visa mer',
  'fabric.editor.viewMoreAriaLabel': 'Visa alla element',
  'fabric.editor.visit': 'Öppna länk i nytt fönster',
  'fabric.editor.warning': 'Varning',
  'fabric.editor.warningPanel': 'Varningspanel',
  'fabric.editor.warningPanel.description': 'Lägg till en varning i en färgad panel',
  'fabric.editor.wrapLeft': 'Radbyte vänster',
  'fabric.editor.wrapRight': 'Radbyte höger',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Blå',
  'fabric.theme.bold-blue': 'Starkblå',
  'fabric.theme.bold-gray': 'Starkgrå',
  'fabric.theme.bold-green': 'Starkgrön',
  'fabric.theme.bold-magenta': 'Starkt magenta',
  'fabric.theme.bold-orange': 'Starkorange',
  'fabric.theme.bold-purple': 'Starklila',
  'fabric.theme.bold-red': 'Starkröd',
  'fabric.theme.bold-teal': 'Starkt blågrön',
  'fabric.theme.bold-yellow': 'Starkgul',
  'fabric.theme.bolder-blue': 'Starkare blå',
  'fabric.theme.bolder-gray': 'Starkare grå',
  'fabric.theme.bolder-green': 'Starkare grön',
  'fabric.theme.bolder-magenta': 'Starkare magenta',
  'fabric.theme.bolder-orange': 'Starkare orange',
  'fabric.theme.bolder-purple': 'Starkare lila',
  'fabric.theme.bolder-red': 'Starkare röd',
  'fabric.theme.bolder-teal': 'Starkare mörkblå',
  'fabric.theme.bolder-yellow': 'Starkare gul',
  'fabric.theme.dark-blue': 'Mörkblå',
  'fabric.theme.dark-gray': 'Mörkgrå',
  'fabric.theme.dark-green': 'Mörkgrön',
  'fabric.theme.dark-purple': 'Mörklila',
  'fabric.theme.dark-red': 'Mörkröd',
  'fabric.theme.dark-teal': 'Mörkteal',
  'fabric.theme.dark-yellow': 'Mörkgul',
  'fabric.theme.default': 'Standard',
  'fabric.theme.gray': 'Grå',
  'fabric.theme.green': 'Grön',
  'fabric.theme.light-blue': 'Ljusblå',
  'fabric.theme.light-gray': 'Ljusgrå',
  'fabric.theme.light-green': 'Ljusgrön',
  'fabric.theme.light-purple': 'Ljuslila',
  'fabric.theme.light-red': 'Ljusröd',
  'fabric.theme.light-teal': 'Ljust blågrön',
  'fabric.theme.light-yellow': 'Ljusgul',
  'fabric.theme.lime': 'Lime',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Ingen markering',
  'fabric.theme.orange': 'Orange',
  'fabric.theme.purple': 'Lila',
  'fabric.theme.red': 'Röd',
  'fabric.theme.subtle-blue': 'Dämpad blå',
  'fabric.theme.subtle-gray': 'Dämpad grå',
  'fabric.theme.subtle-green': 'Dämpad grön',
  'fabric.theme.subtle-magenta': 'Dämpad magenta',
  'fabric.theme.subtle-orange': 'Dämpad orange',
  'fabric.theme.subtle-purple': 'Dämpad lila',
  'fabric.theme.subtle-red': 'Dämpad röd',
  'fabric.theme.subtle-teal': 'Dämpad blågrön',
  'fabric.theme.subtle-yellow': 'Dämpad gul',
  'fabric.theme.teal': 'Blågrön',
  'fabric.theme.white': 'Vit',
  'fabric.theme.yellow': 'Gul',
  'fabrid.editor.rowNumbers': 'Radnummer',
  'rovo.agents.dropdown.title': 'Agenter',
  'rovo.agents.dropdown.viewAgents.label': 'Visa alla agenter',
};
